import React from 'react';
import { Box, Checkbox, Typography } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import { functionFormatTime, timeStampToNumberedDateString } from '../../../utils/commonServices';
import CustomTooltip from '../../../components/CustomTooltip';

const Thumbnail = ({revision, selectedVideos, item, isSelected, onClick, handleVideoSelect, onChange}) => {
    console.log(revision, 'revision-----------')
  return (
    <Box
      sx={{
        position: 'relative',
      // width:'100%', 
        width: { xs: '160px', sm: '160px', md:'180px',lg: '210px' ,xl:'320px'}, 
        height: { xs: '120px', sm: '130px', md:'130px',lg: '150px' ,xl:'220px'}, // Responsive height
        backgroundImage: `url(${revision?.thumbnail_url})`, // Replace with your image URL
        
        backgroundPosition: 'center',
        borderRadius: '8px',
        overflow: 'hidden',
         border: '1px solid #ccc',
         mt:'5px',
         backgroundRepeat:'no-repeat', 
         backgroundColor:'#222',
         backgroundSize:'cover',
         border: isSelected
                       
         ? {xs:'3px solid #00d744', xl:'4px solid #00d744' } // Highlight selected videos
                        : {xs: '3px solid #dedede' , xl: '4px solid #dedede'},
                        cursor:'pointer'
      }}
      onClick={onClick}
    >
 
 {/* Hidden Checkbox */}
 <Checkbox
        sx={{
          position: 'absolute',
          top: 8,
          left: 8,
          width: 0,
          height: 0,
          opacity: 0,
          pointerEvents: 'none', // Completely hide and disable visual interaction
        }}
        // checked={isChecked}
        readOnly
        checked={selectedVideos.includes(revision.id)} 
        // onChange={onChange} 
      />

      {/* Custom Design for Checkbox */}
      <Box
      onClick={onChange}
        sx={{
          position: 'absolute',
          top: 8,
          left: 8,
          width: {xs:'14px', md:'16px',lg:'18px',xl:'24px'},
          height:{xs: '14px', md:'16px',lg:'18px',xl:'24px'},
          // backgroundColor: selectedVideos.includes(revision.id) ? '#00d744' : 'rgba(255, 255, 255, 0.5)', 
          backgroundColor: selectedVideos.includes(revision.id) ? '#00d744' : 'rgba(255, 255, 255, 0.4)',
          borderRadius: '4px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          // border:'2px solid black'
        }}
      >
        {selectedVideos.includes(revision.id) && (
          <CheckIcon
            sx={{
              color: 'white !important',
            //   backgroundColor:'white !important',
              fontSize: '18px', // Small icon size
            }}
          />
        )}
      </Box>

      {/* Grayish background at the bottom */}
      <Box
        sx={{
          position: 'absolute',
          bottom: 0,
          width: '100%',
          height: '20%', // Lower 20% of the thumbnail
          backgroundColor: 'rgba(0, 0, 0, 0.7)', // Gray background with opacity
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'flex-start',
          padding: '8px',
          pt:'4px',
          pb:'4px'
        }}
      >
        <Box sx={{display:'flex' , flexDirection:'row', justifyContent:'space-between', width:'100%'}}>
        <Typography
          variant="caption"
          sx={{
            color: '#fff', // White text for better contrast
            fontSize: {xs:'7px', md:'7px',lg:'8px', xl:'11px'},
            lineHeight:1.2
          }}
        >
         {`${timeStampToNumberedDateString(revision?.created_at)}`}
        </Typography>
        <Typography
          variant="caption"
          sx={{
            color: '#fff', // White text for better contrast
            fontSize: {xs:'7px', md:'7px',lg:'8px', xl:'11px'},
            lineHeight:1.2
          }}
        >
            {`(Version: ${revision?.version})`}
        </Typography>
        </Box>
     
        <CustomTooltip title={revision?.filename}>
        <Typography
          variant="body2"
          sx={{
            color: '#fff',
            fontSize:{xs:'9px', lg:'10px', xl:'13px'},
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            width:'100%',
            pr:0.5,
            lineHeight:1.2
          }}
        >
          {revision?.filename}
        </Typography>
        </CustomTooltip>
      </Box>

      {/* Black tag above the transparent area */}
      <Box
        sx={{
          position: 'absolute',
          bottom: '22%', // Positioned just above the gray area
          right: 8,
          backgroundColor: '#000', // Black background
          color: '#fff', // White text
          padding: '2px 6px',
          borderRadius: '4px',
          fontSize: {xs:'7px', md:'8px',lg:'9px', xl:'12px'},
        }}
      >
        {revision?.video_duration ? functionFormatTime(revision?.video_duration): '00:00'}
      </Box>
    </Box>
  );
};

export default Thumbnail;
